import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle--right",
  "use": "icon-triangle--right-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"icon-triangle--right\"><path d=\"M7.205 5.265a1 1 0 0 1 0 1.47l-5.026 4.643c-.64.591-1.679.137-1.679-.735V1.357C.5.485 1.538.03 2.179.622l5.026 4.643Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol